import React, { forwardRef } from 'react';

export const SelectInput = forwardRef(({ 
  selectName,
  currentValue,
  isMultiple,
  multipleSize,
  placeholder,
  options,
  fontFamily,
  onChange,
  onBlur
}, ref) => {
  // Handle multiple vs single selection values
  const selectValue = isMultiple 
    ? (Array.isArray(currentValue) ? currentValue : []) 
    : (currentValue || "");

  return (
    <select
      ref={ref}
      name={selectName}
      value={selectValue}
      multiple={isMultiple}
      size={isMultiple ? multipleSize : undefined}
      onChange={onChange}
      onBlur={onBlur}
      style={{
        fontFamily: fontFamily,
        width: "100%"
      }}
    >
      {!isMultiple && placeholder && (
        <option value="" disabled>
          {placeholder}
        </option>
      )}
      {options.map((option, index) => (
        <option key={index} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
});